












// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseProfilExclusion from '@/components/profilExclusion/edit/EditBaseProfilExclusion.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { toSubArray } from '@/utils/groupBy'
import { getDefaultAloProfilExclusion, AloProfilExclusion } from '@/models/alo/AloProfilExclusion'

@Component({
  name: 'EditFlux',    
  components:{EditBaseProfilExclusion}
})
export default class EditFlux extends Vue {
  
  private profilExclusion = getDefaultAloProfilExclusion()
  
  edit(item:AloProfilExclusion) {    
    this.profilExclusion = (this.$refs.baseEdit as EditBaseProfilExclusion).edit(item)
  }  

  get fluxList() {
    //@ts-ignore    
    return this.$store.myGetters.fluxList
  }

  get fluxGroup(){
    return toSubArray(this.fluxList,3)
  }
}
